export default function Differentiation() {
  const comparisons = [
    {
      not: 'We are not a 3PL',
      notDesc: 'We do not compete with logistics providers',
      are: 'We coordinate readiness',
      areDesc: 'We work alongside your existing logistics partners to improve visibility and accountability'
    },
    {
      not: 'We are not a software vendor',
      notDesc: 'We do not sell dashboards detached from execution',
      are: 'We deliver operational outcomes',
      areDesc: 'Technology-enabled coordination with hands-on readiness management'
    },
    {
      not: 'We are not a traditional consultant',
      notDesc: 'We do not deliver slide decks and exit',
      are: 'We own readiness accountability',
      areDesc: 'Ongoing operational partnership focused on high-urgency component predictability'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
            <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Our Position</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332]">
            How We Are Different
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {comparisons.map((comparison, index) => (
            <div key={index} className="relative">
              {index < comparisons.length - 1 && (
                <div className="hidden md:block absolute top-0 right-0 w-px h-full bg-gray-200"></div>
              )}
              
              <div className="p-6">
                <div className="mb-6">
                  <h3 className="text-2xl font-bold text-gray-400 line-through mb-3">
                    {comparison.not}
                  </h3>
                  <p className="text-[#5A6670]">
                    {comparison.notDesc}
                  </p>
                </div>

                <div className="h-px bg-gray-200 my-6"></div>

                <div>
                  <h3 className="text-2xl font-bold text-[#0A5F5C] mb-3">
                    {comparison.are}
                  </h3>
                  <p className="text-[#1A2332] font-medium">
                    {comparison.areDesc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-[#1A2332] font-semibold">
            BrightSync operates as a readiness owner focused specifically on high-urgency components tied to operational continuity.
          </p>
        </div>
      </div>
    </section>
  );
}
